module.exports = __webpack_public_path__ + "img/omnichat-logo.daebac64.png";